module.exports = __webpack_public_path__ + "img/baoguang.a9809cc8.png";